<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6LUC5']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['130'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codinput" name="coddesc_codinput">{{ detail.tab1.codinput }} - {{ detail.tab1.desc_codinput }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block">
                <div class="detail-header">
                  {{ labels['HRES6LUC5']['40'] }}
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="dtestrt" name="dtestrt">{{ setDateOutput(detail.tab1.dtestrt) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="dteend" name="dteend">{{ setDateOutput(detail.tab1.dteend) }}</div>
                  </div>
                </div>
              </div>

              <div class="">
                <div class="detail-header">
                  {{ labels['HRES6LUC5']['70'] }}
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['80'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text-half-left text-center"  id="timbstr" name="timbstr">{{ detail.tab1.timbstr }}</div>
                      <div class="detail-text-half-right text-center" id="timbend" name="timbend">{{ detail.tab1.timbend }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['90'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text-half-left text-center"  id="timdstr" name="timdstr">{{ detail.tab1.timdstr }}</div>
                      <div class="detail-text-half-right text-center" id="timdend" name="timdend">{{ detail.tab1.timdend }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['100'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text-half-left text-center"  id="timastr" name="timastr">{{ detail.tab1.timastr }}</div>
                      <div class="detail-text-half-right text-center" id="timaend" name="timaend">{{ detail.tab1.timaend }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC5']['110'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codrem" name="coddesc_codrem">{{ detail.tab1.codrem }} - {{ detail.tab1.desc_codrem }}</div>
                  </div>
                </div>

                <div class="detail-responsive">
                  <div class="clearfix detail-row">
                      <div class="detail-left label-left">{{ labels['HRES6LUC5']['120'] }}</div>
                      <div class="detail-right">
                          <div class="detail-text width-100 txtarea-width response-full-width" id="remark" name="remark">{{ detail.tab1.remark }}</div>
                      </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
 
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6LUC3']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6LUC3']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.detail.codempid }} - {{ detail.tab2.detail.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6LUC3']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="dteBtw" name="dteBtw">{{ setDateOutput(detail.tab2.detail.dteworkst) }} - {{ setDateOutput(detail.tab2.detail.dteend) }}</div>
                </div>
              </div>

            </div>

            <hrms-table :columns="tab2Table" :data="detail.tab2.table" />
                   
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6LUC4']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
         
              <div class="detail detail-responsive">

                <!--<div class="detail-header">
                  <div class="">{{ labels['HRES6LUC4']['10'] }}</div>
                </div>-->

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6LUC4']['20'] }}</div>
                  <div class="detail-right" style="margin-bottom:10px;">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab3.detail.codempid }} - {{ detail.tab3.detail.desc_codempid }}</div>
                  </div>
                </div>
              </div>

              <hrms-table :columns="tab3Table" :data="detail.tab3.table"  />
                   
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres6lu-detail',
  props: [ 'labels', 'detail', 'toggle', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'tab2Table', 'tab3Table', 'data', 'indexSelected', 'nowLang', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?58ab181d